import { AppConstants as _app } from '@/shared/app.constants';

import { Ability } from '@casl/ability';
// import AuthService from '@/services/auth.service';
// const auth = new AuthService();
let abilities = [];

// auth.getUser().then((user) => {
//     if(user.profile.role_id === _app.appRoles.ProgramAdmin) {
//         abilities.push({
//             action: 'manage',
//             subject: 'all'
//         });
//     }
// })
export default new Ability(abilities);
